<svg class="{{ class }}">
  <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ icon }}"></use>
</svg>
